import { render, staticRenderFns } from "./detentionRights.vue?vue&type=template&id=2d40ebf8"
import script from "./detentionRights.vue?vue&type=script&lang=js"
export * from "./detentionRights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports